export default function WhyChooseAustralia() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-8">

                {/* Main Heading */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Why Choose an Australia Student Visa Consultant?
                </h3>

                {/* Intro */}
                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Planning to study in Australia involves multiple important steps —
                        selecting the right course, meeting visa requirements, arranging finances,
                        and preparing for relocation. A professional Australia Student Visa Consultant
                        simplifies this entire journey and ensures a smooth, transparent, and stress-free process.
                    </p>
                    <p>
                        At Shivasya, our experienced consultants guide students at every stage —
                        from course selection to successful visa approval — ensuring compliance
                        with Australian immigration regulations and education standards.
                    </p>
                </div>

                {/* RPL */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Recognition of Prior Learning (RPL) Guidance
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Recognition of Prior Learning (RPL) evaluates a student’s existing skills,
                        work experience, and qualifications to grant academic credit. Our consultants assist with:
                    </p>
                    <p>
                        • Skill assessment and eligibility review<br />
                        • Portfolio preparation and submission<br />
                        • Identifying additional training if required<br />
                        • Reducing course duration where possible<br />
                        • Supporting career advancement and migration pathways
                    </p>
                </div>

                {/* Accreditation */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Ensuring Accreditation and Education Standards
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        We assist students in selecting institutions registered under CRICOS
                        and compliant with Australian education regulations. Our consultancy ensures:
                    </p>
                    <p>
                        • Verification of institution legitimacy<br />
                        • Selection of accredited programs<br />
                        • Clear understanding of course outcomes<br />
                        • Informed academic decision-making
                    </p>
                </div>

                {/* AQF */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Understanding the Australian Qualifications Framework (AQF)
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        The Australian Qualifications Framework (AQF) consists of 10 qualification
                        levels that regulate education standards in Australia. Our consultants:
                    </p>
                    <p>
                        • Explain AQF levels and academic pathways<br />
                        • Assist in choosing AQF-compliant courses<br />
                        • Guide long-term academic progression planning<br />
                        • Provide insight into industry recognition and migration opportunities
                    </p>
                </div>

                {/* OSHC */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Overseas Student Health Cover (OSHC) Assistance
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        OSHC is mandatory for international students in Australia.
                        We assist students with:
                    </p>
                    <p>
                        • Selecting approved OSHC providers<br />
                        • Comparing coverage options and costs<br />
                        • Enrollment and documentation support<br />
                        • Renewal and extension assistance<br />
                        • Claims guidance and policy clarification
                    </p>
                </div>

                {/* Pre Departure */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Pre-Departure Support
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Relocating to Australia involves more than obtaining a visa.
                        We provide:
                    </p>
                    <p>
                        • Accommodation guidance<br />
                        • Travel and arrival preparation<br />
                        • Cultural orientation<br />
                        • Emotional and practical support<br />
                        • Compliance guidance with Australian regulations
                    </p>
                </div>

                {/* Skilled Migration */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Skilled Migration Pathway Guidance
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        For students planning long-term career opportunities in Australia,
                        we provide expert guidance on:
                    </p>
                    <p>
                        • Temporary Graduate Visa (Subclass 485)<br />
                        • General Skilled Migration (GSM) pathways<br />
                        • Eligibility assessments<br />
                        • English language requirements<br />
                        • Skills and work experience documentation
                    </p>
                    <p>
                        Our goal is to help students transition smoothly from education
                        to employment and potentially permanent residency in Australia.
                    </p>
                </div>

                {/* Final Section */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    How Does an Australia Student Visa Consultant Help?
                </h3>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        With numerous top-ranking universities and visa options available,
                        students often require professional assistance to make the right decisions.
                        From institution selection and financial documentation to visa filing,
                        interview preparation, visa extensions, and reapplications —
                        expert consultants ensure accuracy and compliance throughout the process.
                    </p>
                    <p>
                        • Assists in selecting suitable institutions<br />
                        • Identifies the correct visa category<br />
                        • Ensures accurate and complete documentation<br />
                        • Provides interview preparation<br />
                        • Supports visa extensions and reapplications<br />
                        • Offers post-visa assistance<br />
                    </p>

                    <p>
                        Shivasya’s experienced team simplifies complex immigration procedures
                        and provides end-to-end support, helping students confidently pursue
                        their dream of studying in Australia.
                    </p>
                </div>

            </div>
        </section>
    );
}